var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenario19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Volunteer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 15.798V14.798H20.5V12.798H19.5V11.798H17.5V15.798H19.5ZM5.5 12.798V11.798H7.5V15.798H5.5V14.798H4.5V12.798H5.5ZM6.5 6.79803H8.64C9 5.39803 10.1 4.29803 11.5 3.93803V2.79803H13.5V3.93803C14.9 4.29803 16 5.39803 16.36 6.79803H18.5V8.79803H6.5V6.79803ZM6.5 22.798H18.5C18.5 21.698 17.6 20.798 16.5 20.798V9.79803H8.5V20.798C7.96957 20.798 7.46086 21.0087 7.08579 21.3838C6.71071 21.7589 6.5 22.2676 6.5 22.798ZM14.5 13.798C14.5 14.3285 14.2893 14.8372 13.9142 15.2122C13.5391 15.5873 13.0304 15.798 12.5 15.798C11.9696 15.798 11.4609 15.5873 11.0858 15.2122C10.7107 14.8372 10.5 14.3285 10.5 13.798C10.5 12.688 11.39 11.798 12.5 11.798C13.61 11.798 14.5 12.698 14.5 13.798Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.5 6.79803H8.64C9 5.39803 10.1 4.29803 11.5 3.93803V2.79803H13.5V3.93803C14.9 4.29803 16 5.39803 16.36 6.79803H18.5V8.79803H6.5V6.79803Z",
    fill: "#14AA3C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario19);
export default __webpack_public_path__ + "static/media/Scenario19.741fb8ffbfcc84d77d4cfaf24459fd05.svg";
export { ForwardRef as ReactComponent };